/* eslint-disable no-unused-vars */
import React, { useState, Fragment, useEffect, useRef, memo } from "react";
import "./style.scss";
import {
  Button,
  Drawer,
  Space,
  Table,
  message,
  Row,
  Col,
  Input,
  Tooltip,
  notification,
  Form,
} from "antd";
import {
  checkNumbervalue,
  checkSpecialCharacter,
  validateNumberMinValue,
  isValidDocumentNum,
} from "../../../../utils";
// import useEwayBill from "../../RetailBooking/AddressForm/ewayBillCompo";

import { ReactComponent as Edit_icon } from "../../../../assests/images/edit-logo.svg";
import { ReactComponent as DeleteIcon } from "../../../../assests/images/deleteIcon.svg";
import { focusFirstInputAndScrollToTop } from "../../../../components/CustomFunctions";
import urls from "../../../../api/urls";
import API from "../../../../api";
import useClientAndDepartment from "../useClientAndDepartment ";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import ChildDocumentRow from "./dynamicChild";

const ChildDrawer = ({
  childShipments,
  setOpen,
  open,
  setSummaryData = () => {},
  setChildShipments = () => {},
  childDrawerform,
  editChildDetails,
  editAwb,
}) => {
  const { userInfo } =
    JSON.parse(window?.localStorage?.getItem("userId")) || "";

  const { documentValidate, handleOnEnter } = useClientAndDepartment(
    userInfo,
    null
  );

  // console.log(childShipments, "CHILD");

  const [edit, setEdit] = useState(null);
  const [showSubmit, setShowSubmit] = useState(false);

  const [loading, setLoading] = useState(false);
  const { CHECK_CHILD_AWB_USED } = urls;

  const [childAwbError, setChildAwbError] = useState({});
  const [count, setCount] = useState(0);
  const [childData, setChildData] = useState([]);
  const [multipleChildStatus, setMultipleChildStatus] = useState({});
  const [currentEditble, setCurrentEditble] = useState(null);

  const columns = [
    {
      title: "SI",
      dataIndex: "",
      key: "",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Document number",
      dataIndex: "childDocumentNumber",
      key: "childDocumentNumber",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
      render: (text) => text || "--",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
      render: (text) => text || "--",
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
      render: (text) => text || "--",
    },

    {
      title: "Vol weight",
      dataIndex: "volumetricWeight",
      key: "volumetricWeight",
      render: (text) => text || "--",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "action",
      render: (text, item, idx) => {
        return (
          item?.editable == true && (
            <div className="d-flex">
              <Tooltip title="Edit" placement="bottom">
                <Space onClick={() => handleEdit(idx, item?.editable)}>
                  <Edit_icon className="pointer" />
                </Space>
              </Tooltip>

              <Tooltip title="Delete" placement="bottom">
                <Space onClick={() => handleDelete(idx)}>
                  <DeleteIcon className="pointer" />
                </Space>
              </Tooltip>
            </div>
          )
        );
      },
    },
  ];

  // const filterColumns = columns?.filter(
  //   (col) => !(editAble && col?.key === "action")
  // );

  useEffect(() => {
    if (open) {
      focusFirstInputAndScrollToTop("child-1");
    }
  }, [open]);

  const onClose = () => {
    setOpen(false);
  };

  const handleDelete = (params) => {
    setEdit(null);
    let temp = childShipments?.filter((val, idx) => idx !== params);
    setChildShipments(temp);
  };

  const handleEdit = (params, isEditable = true) => {
    setEdit(params);

    let temp = childShipments[params];
    if (!isEditable) {
      let currentEdit = editChildDetails[params];
      setCurrentEditble(currentEdit);
    }
    childDrawerform.setFieldsValue(temp);
  };

  const volumCalculation = () => {
    let { length, width, height } = childDrawerform.getFieldValue();

    if (length && width && height) {
      const volume = ((+length * +width * +height) / 5000)?.toFixed(2);
      childDrawerform.setFieldsValue({
        volumetricWeight: volume || 0,
      });
    } else {
      childDrawerform.setFieldsValue({
        volumetricWeight: "0.00",
      });
    }
  };

  const formProps = {
    name: "retail-address-form",
    className: "retail-address-form",
    autoComplete: "off",
  };

  const openNotification = (type, message) => {
    notification[type]({
      message: null,
      className: "custom-top-right-drawer-notification",
      duration: 2,
      description: message,
      placement: "topRight",
    });
  };

  function getSubmitMultiple(params) {
    const result = [];

    // Extract the initial item (no index in keys)
    const initialItem = {
      childDocumentNumber: +params.childDocumentNumber,
      weight: params.weight,
      length: params.length,
      width: params.width,
      height: params.height,
      volumetricWeight: params.volumetricWeight,
      editable: true,
    };
    result.push(initialItem);

    // Extract additional items (keys with indices)
    let index = 0;
    while (params[`childDocumentNumber${index}`] !== undefined) {
      const item = {
        childDocumentNumber: params[`childDocumentNumber${index}`],
        weight: params[`weight${index}`],
        length: params[`length${index}`],
        width: params[`width${index}`],
        height: params[`height${index}`],
        volumetricWeight: params[`volumetricWeight${index}`],
        editable: true,
      };
      result.push(item);
      index++;
    }

    return result;
  }

  const checkDuplicateShipment = (childShipments, params, editIndex, idx) => {
    if (childShipments?.length) {
      const isDuplicate = childShipments.some(
        (item) => +item?.childDocumentNumber === +params
      );

      const currentIdx = childShipments.findIndex(
        (item) => +item?.childDocumentNumber === +params
      );

      if (isDuplicate && currentIdx !== editIndex) {
        // if (idx !== null && idx !== undefined) {
        //   console.log(idx, "first");

        //   let temp = [...childData];
        //   temp[idx].error = "Doc no. already used";
        //   setChildData(temp);
        // }
        // childDrawerform.setFieldsValue

        return {
          status: "error",
          msg: "Doc no. already used",
          id:
            idx !== null && idx !== undefined
              ? `childDocumentNumber${idx}`
              : "",
        };
      }
    }
    return null;
  };

  const onSubmitFormData = (params) => {
    if (childAwbError?.status == "error") {
      // message.error(childAwbError?.msg || "Network error");
      return true;
    }

    if (childData?.length) {
      if (multipleChildStatus?.status == "error") {
        return true;
      }
    }

    const result = checkDuplicateShipment(
      childShipments,
      params?.childDocumentNumber,
      edit
    );

    if (result) {
      setChildAwbError(result);
      return;
    }

    let data = getSubmitMultiple(params);

    if (edit === null) {
      setChildShipments((prevItems) => {
        const prevItemsArray = Array.isArray(prevItems) ? prevItems : [];
        const updatedItems = [...prevItemsArray, ...data];
        openNotification("success", "Added successfully");
        setCount(0);
        setShowSubmit(false);
        setChildData([]);
        focusFirstInputAndScrollToTop("child-1");
        return updatedItems;
      });
      let childDocumentNumber =
        +data[data?.length - 1]?.childDocumentNumber + 1;
      childDrawerform.resetFields();
      handleAPI(childDocumentNumber);
      childDrawerform.setFieldsValue({
        childDocumentNumber: childDocumentNumber,
      });
    } else {
      childDrawerform.resetFields();

      setChildShipments((prevItems) => {
        const temp = [...prevItems];
        // const removeNull = replaceUndefinedWithNull(temp);
        temp[edit] = params;
        temp[edit].editable = currentEditble ? false : true;
        return temp;
      });
    }

    setEdit(null);
    setCurrentEditble(null);
  };

  const currentEnv = process.env.REACT_APP_ENV;
  const debounceTimeout = useRef(null);

  async function handleAPI(value) {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      // if (value?.toString()?.length == 11 && currentEnv == "prod") {
      if (value?.toString()?.length == 11) {
        setLoading(true);

        const result = checkDuplicateShipment(childShipments, value, edit);

        if (result) {
          setLoading(false);

          setChildAwbError(result);
          return;
        }
        const response = await documentValidate(
          value,
          "Account",
          "ChildBadgeCourier"
        );
        if (response?.status) {
          setLoading(false);
          setChildAwbError({
            status: "success",
            msg: null,
          });
          // setShowSubmit(true);
        } else {
          // message.error(response?.response?.data?.message);
          setLoading(false);
          setChildAwbError({
            status: "error",
            msg: response?.response?.data?.message || "Invalid doc no.",
          });
        }
      }
    }, 700);
  }

  const deleteItem = (index) => {
    const updatedData = childData?.filter((_, i) => i !== index);
    setChildData(updatedData);

    const fields = updatedData?.reduce((acc, item, i) => {
      acc[`childDocumentNumber${i}`] = item?.docNumber;
      return acc;
    }, {});
    childDrawerform.setFieldsValue(fields);
    setCount((prevCount) => prevCount - 1);
  };

  const handleMultipleAPI = async (data) => {
    let value = data?.target ? data?.target?.value : data;

    if (value?.toString()?.length === 11) {
      setLoading(true);

      const response = await documentValidate(
        value,
        "Account",
        "ChildBadgeCourier"
      );
      if (response?.status) {
        setLoading(false);
        setShowSubmit(true);
        setMultipleChildStatus({
          status: "success",
          id: data?.target?.id,
          msg: null,
        });
      } else {
        setLoading(false);
        setMultipleChildStatus({
          status: "error",
          id: data?.target?.id,
          msg: response?.response?.data?.message || "Invalid doc no.",
        });
        message.error(
          value + " " + response?.response?.data?.message || "Invalid doc no."
        );
        throw new Error(
          value + " " + response?.response?.data?.message || "Invalid doc no."
        );
      }
    } else {
      message.error("Invalid doc number");
      throw new Error("Invalid document number length.");
    }
  };

  const handleAddMultiple = async () => {
    if (count < 1) {
      message.error("Count should not be less than 1");
      return;
    }

    try {
      const formValues = await childDrawerform.validateFields([
        "childDocumentNumber",
        "width",
        "length",
        "weight",
        "height",
        "volumetricWeight",
      ]);

      let {
        childDocumentNumber,
        width,
        length,
        weight,
        height,
        volumetricWeight,
      } = formValues;

      const lastDocNumber = +childDocumentNumber + +count;

      // Perform the API call
      await handleMultipleAPI(lastDocNumber);

      // Generate new data
      const newData = Array.from({ length: count }, (_, index) => ({
        docNumber: ++childDocumentNumber,
        length,
        width,
        weight,
        height,
        volumetricWeight,
      }));

      setChildData((prev) => [...newData]);

      // Prepare fields for setting in the form
      const fields = newData.reduce((acc, item, index) => {
        acc[`childDocumentNumber${index}`] = item.docNumber;
        acc[`width${index}`] = width;
        acc[`length${index}`] = length;
        acc[`weight${index}`] = weight;
        acc[`height${index}`] = height;
        acc[`volumetricWeight${index}`] = volumetricWeight;

        const result = checkDuplicateShipment(
          childShipments,
          +item.docNumber,
          edit,
          index
        );

        if (result) {
          setMultipleChildStatus(result);
        }

        return acc;
      }, {});

      childDrawerform.setFieldsValue(fields);
    } catch (error) {
      if (error.name === "ValidationError") {
        message.error("Please correct the form errors before proceeding.");
      }
      return;
    }
  };

  // console.log(currentEditble, "currentEditble");
  // console.log(multipleChildStatus, "multipleChildStatus");
  return (
    <>
      <Drawer
        title={"Add/ View child shipment"}
        placement="right"
        // size={size}
        width={780}
        onClose={onClose}
        // open={open || true}
        open={open}
        className="credit-child-drawer"
      >
        <div className="child-drawer-container">
          <Fragment>
            <div className="bounce">
              Do not add child weight with parent weight, System will
              automatically calculate total weights (child + parent).
            </div>
            {/* <p>24400995351</p> */}
            {!editAwb && (
              <Form
                form={childDrawerform}
                {...formProps}
                initialValues={{
                  length: 0,
                  width: 0,
                  height: 0,
                  volumetricWeight: "0.00",
                }}
                onFinish={onSubmitFormData}
                layout="vertical"
                //   onFieldsChange={onFeildsChange} // layout={formLayout}
                scrollToFirstError={{
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }}
                // disabled={editAble}
                className="global-form"
              >
                <Row className="global-form-row">
                  <Row align={"center"}>
                    <Col style={{ width: "22%" }}>
                      <Form.Item
                        label="Child doc number"
                        validateStatus={childAwbError?.status}
                        help={childAwbError?.msg}
                        className=""
                        name="childDocumentNumber"
                        type="input"
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleOnEnter(event);
                          } else if (checkNumbervalue(event)) {
                            event.preventDefault();
                          }
                        }}
                        rules={[
                          {
                            required: true,
                            message: null,
                          },
                          () => ({
                            validator: (_, value) => {
                              if (!value) {
                                setChildAwbError({
                                  status: "error",
                                  msg: "Enter doc no.",
                                });
                              }
                              if (value?.length > 0 && value?.length < 11) {
                                setChildAwbError({
                                  status: "error",
                                  msg: "Doc no. should be 11 digits",
                                });
                              }

                              return Promise.resolve();
                            },
                            validateTrigger: "onSubmit",
                          }),
                        ]}
                      >
                        <Input
                          disabled={currentEditble}
                          placeholder="Doc number"
                          id="child-1"
                          maxLength={11}
                          onChange={(e) => {
                            if (e.target.value.length == 0) {
                              setChildAwbError({});
                            } else {
                              handleAPI(e?.target?.value);
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ width: "14%" }}>
                      <Form.Item
                        label="Weight(Kg)"
                        name="weight"
                        rules={[
                          {
                            required: true,
                            message: null,
                          },
                          () => ({
                            validator(_, data) {
                              let value = String(data);

                              if (!value || !value?.length || !data) {
                                return Promise.reject("Enter weight");
                              }

                              if (currentEditble) {
                                if (+value < +currentEditble?.weight) {
                                  return Promise.reject(
                                    "Cannot be below original " +
                                      "(" +
                                      currentEditble?.weight +
                                      "kg )"
                                  );
                                }
                              }

                              if (
                                parseInt(value?.toString()?.substring(1, 0)) ===
                                0
                              ) {
                                return Promise.reject("Min weight: 1 kg");
                              }

                              if (value && value?.split(".")?.length > 2) {
                                return Promise.reject(
                                  "Only one decimal allowed"
                                );
                              }

                              if (value > 499.99) {
                                return Promise.reject("Max weight: 499 kg");
                              }
                              return Promise.resolve();
                            },
                            //validateTrigger: "onSubmit",
                          }),
                        ]}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleOnEnter(event);
                          } else if (checkNumbervalue(event)) {
                            event.preventDefault();
                          }
                        }}
                      >
                        <Input
                          placeholder="weight"
                          maxLength={6}
                          onChange={volumCalculation}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ width: "14%" }}>
                      <Form.Item
                        label={
                          <span className="calculater-container-pikpin">
                            {" "}
                            Length(Cm)
                          </span>
                        }
                        name="length"
                        className=""
                        rules={[
                          {
                            required: false,
                            message: "Enter length",
                          },
                          // validateNumberMinValue("cannot be 0")(),
                        ]}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleOnEnter(event);
                          } else if (
                            checkNumbervalue(event) ||
                            event.key === "."
                          ) {
                            event.preventDefault();
                          }
                        }}
                      >
                        <Input
                          placeholder="length"
                          maxLength={3}
                          onChange={volumCalculation}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ width: "14%" }}>
                      <Form.Item
                        label="Width(Cm)"
                        className=""
                        name="width"
                        rules={[
                          {
                            required: false,
                            message: "Enter width",
                          },
                          // validateNumberMinValue("cannot be 0")(),
                        ]}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleOnEnter(event);
                          } else if (
                            checkNumbervalue(event) ||
                            event.key === "."
                          ) {
                            event.preventDefault();
                          }
                        }}
                      >
                        <Input
                          placeholder="width"
                          maxLength={3}
                          onChange={volumCalculation}
                          min={"0"}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ width: "14%" }}>
                      <Form.Item
                        className=""
                        label={
                          <span className="calculater-container-pikpin">
                            Height (Cm)
                          </span>
                        }
                        name="height"
                        rules={[
                          {
                            required: false,
                            message: "Enter height",
                          },
                          // validateNumberMinValue("cannot be 0")(),
                        ]}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleOnEnter(event);
                          } else if (
                            checkNumbervalue(event) ||
                            event.key === "."
                          ) {
                            event.preventDefault();
                          }
                        }}
                      >
                        <Input
                          className=""
                          placeholder="height"
                          maxLength={3}
                          onChange={volumCalculation}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ width: "15%" }}>
                      <Form.Item
                        label="Vol weight (Kg)"
                        name="volumetricWeight"
                        // dependencies={["length"]}
                        dependencies={["length", "width", "height"]} // Ensure validation triggers when weight changes
                        validateTrigger={["onChange", "onBlur"]}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const currentWeight =
                                currentEditble?.volumetricWeight;

                              if (
                                +childDrawerform.getFieldValue(
                                  "volumetricWeight"
                                ) < +currentWeight
                              ) {
                                childDrawerform.setFields([
                                  {
                                    name: "volumetricWeight",
                                    errors: [
                                      `Cannot be below original (${currentWeight} kg)`,
                                    ],
                                  },
                                ]);
                                return Promise.reject(
                                  `Cannot be below original (${currentWeight} kg)`
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          className=""
                          placeholder="Volumetric"
                          disabled
                          type="number"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <ChildDocumentRow
                    multipleChildStatus={multipleChildStatus}
                    handleMultipleAPI={handleMultipleAPI}
                    childDrawerform={childDrawerform}
                    childData={childData}
                    deleteItem={deleteItem}
                    // setChildAwbError={setChildAwbError}
                    setMultipleChildStatus={setMultipleChildStatus}
                  />
                </Row>
                {edit == null ? (
                  <Row
                    gutter={16}
                    style={{
                      display: "flex",
                      marginLeft: "10px",
                      // justifyContent: "space-around",
                      marginTop: "6px",
                    }}
                  >
                    {!showSubmit && (
                      <Col
                        style={{
                          visibility: "visible",
                          // width: "15%",
                        }}
                      >
                        <Button
                          className="child-save-btn mr-1"
                          htmlType="submit"
                          style={{ height: "29px" }}
                        >
                          + ADD SINGLE
                        </Button>
                      </Col>
                    )}
                    <Col
                      style={{
                        // visibility: !editAble ? "visible" : "hidden",
                        width: "12%",
                      }}
                    >
                      <Input
                        placeholder="count"
                        style={{ height: "29px" }}
                        value={count}
                        disabled={
                          showSubmit || childAwbError?.status !== "success"
                        }
                        onChange={(e) => setCount(e.target.value)}
                      />
                    </Col>
                    {showSubmit ? (
                      <Button
                        htmlType="submit"
                        style={{ height: "29px" }}
                        // onClick={handleSubmitMultiple}
                        className="child-save-btn"
                      >
                        SUBMIT
                      </Button>
                    ) : (
                      <Col
                        style={{
                          // visibility: !editAble ? "visible" : "hidden",
                          width: "19%",
                        }}
                      >
                        <Button
                          className="child-save-btn"
                          style={{ height: "29px" }}
                          // htmlType="submit"
                          disabled={childAwbError?.status !== "success"}
                          onClick={handleAddMultiple}
                        >
                          + ADD MULTIPLE
                        </Button>
                      </Col>
                    )}

                    {showSubmit && (
                      <Col
                        style={{
                          // visibility: !editAble ? "visible" : "hidden",
                          width: "15%",
                        }}
                      >
                        <Button
                          className="cancel-btn"
                          style={{ height: "29px" }}
                          onClick={() => {
                            // setChildAwbError({});
                            setCount(1);
                            setChildData([]);
                            setShowSubmit(false);
                            // childDrawerform.resetFields();
                          }}
                        >
                          CANCEL
                        </Button>
                      </Col>
                    )}
                  </Row>
                ) : (
                  <Col
                    style={{
                      // visibility: !editAble ? "visible" : "hidden",
                      // display: "flex",
                      marginLeft: "33px",
                      // marginTop: "6px",
                    }}
                  >
                    <Button
                      className="child-save-btn mr-1"
                      htmlType="submit"
                      style={{ height: "29px" }}
                    >
                      UPDATE
                    </Button>
                  </Col>
                )}
              </Form>
            )}
          </Fragment>
          <Table
            className="mt-1"
            dataSource={childShipments}
            columns={columns}
            pagination={false}
            size="small"
          />
        </div>
      </Drawer>
    </>
  );
};

export default ChildDrawer;
